import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Search from "../../components/Search";
import { getUserProfiles } from "../../actions/userProfilesActions";
import {getUserProfile} from "../../actions/userProfileActions";

const style = () => ({
    dialogContent: {
        minWidth: 300,
    },
    ownerChipWrapper: {
        margin: 8,
    },
});

export class OwnerSketchOrderFilterDialog extends Component {
    state = {
        selectedUser: null,
    };

    async componentDidMount() {
        const queryParams = queryString.parse(this.props.location.search);
        const { ownerUserId } = queryParams;

        if (!ownerUserId) {
            return;
        }

        const result = await this.props.dispatch(getUserProfile(ownerUserId));
        if (result.response) {
            this.setState({
                selectedUser: result.response,
            });
        } else {
            this.setState({
                selectedUser: null,
            })
        }
    }

    searchUserProfiles = async (searchValue) => {
        this.props.dispatch(getUserProfiles(1, searchValue))
    };

    renderUserProfiles = (user) => (
        <ListItem key={user.userId} button onClick={() => this.selectUser(user)}>
            <ListItemText primary={user.userName} />
        </ListItem>
    );

    selectUser = (user) => {
        this.setState({ selectedUser: user });
    };

    applyFilter = async () => {
        const { selectedUser } = this.state;
        const userId = selectedUser ? selectedUser.userId : undefined;
        this.props.onApplyClick(userId);
    };

    removeFilter = () => {
        this.setState({ selectedUser: null });
    };

    render() {
        return (
            <Dialog open={this.props.open} fullScreen={this.props.fullScreen}>
                <DialogTitle>
                    Filter By Owner
                </DialogTitle>
                <DialogContent className={this.props.classes.dialogContent}>
                    <Search onSearch={this.searchUserProfiles} />
                    {
                        this.state.selectedUser &&
                        <div className={this.props.classes.ownerChipWrapper}>
                            <Chip
                                label={this.state.selectedUser.userName}
                                onDelete={this.removeFilter}/>
                        </div>
                    }
                    {
                        this.props.isFetching &&
                        <CircularProgress />
                    }
                    <List>
                        {this.props.userProfiles.map(this.renderUserProfiles)}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onDismissClick}>
                        Dismiss
                    </Button>
                    <Button onClick={this.applyFilter} color="secondary">
                        Apply
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

OwnerSketchOrderFilterDialog.propTypes = {
    dispatch: PropTypes.func.isRequired,
    open: PropTypes.bool,
    onApplyClick: PropTypes.func.isRequired,
    onDismissClick: PropTypes.func.isRequired,
    userProfiles: PropTypes.arrayOf(PropTypes.shape({
        userId: PropTypes.number.isRequired,
        userName: PropTypes.string.isRequired,
    })).isRequired,
    isFetching: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        dialogContent: PropTypes.string.isRequired,
        ownerChipWrapper: PropTypes.string.isRequired,
    }).isRequired,
};

OwnerSketchOrderFilterDialog.defaultProps = {
    open: false,
};

const mapStateToProps = (state) => {
    const { userProfiles: userProfilesStore } = state;
    const {
        userProfiles,
        isFetching
    } = userProfilesStore;

    return {
        userProfiles,
        isFetching
    }
};

export default withRouter(connect(mapStateToProps)(withMobileDialog()(withStyles(style)(OwnerSketchOrderFilterDialog))));
